import * as z from "zod";
import { MAIN_NAV_SCREEN_VALUES } from "./MainNavScreens";
import { LEFT_NAV_STYLE_VALUES } from "./LeftNavStyle";

// Enum preferences use `.catch` rather than `.default` so a stored value that
// has since been removed from the enum (or is missing) falls back to the
// default instead of failing the whole document. This lets us drop screens or
// nav styles without a backfill; the bad value is overwritten the next time the
// user changes the setting.
export const firestoreDocPreferencesSchema = z.object({
  web: z.object({
    home_screen: z.enum(MAIN_NAV_SCREEN_VALUES).catch("HOME"),
    hide_dollar_amounts: z.boolean().default(false),
    left_nav_style: z.enum(LEFT_NAV_STYLE_VALUES).catch("EXPAND_ON_HOVER"),
    default_currency: z.string().default("USD"),
  }),
});

/**
 * This type holds the page state necessary to remember where a user is
 * on the website, and navigate back there when they reopen the page.
 */
export type FirestoreDocPreferences = z.infer<
  typeof firestoreDocPreferencesSchema
>;
